
import React, { useEffect, useRef } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

interface ComprobantesModalPreValidacionesOCRProps {
  open: boolean;
  title?: string;
  message: string;
  onIngresarManual: () => void;
  onVolverACargar: () => void;
}
interface Props {
  onHide: Function;
}

export const ComprobantesModalPreValidacionesOCR: React.FC<ComprobantesModalPreValidacionesOCRProps> = ({
  open,
  title = "Advertencia",
  message,
  onIngresarManual,
  onVolverACargar,
}) => {
  const ingresarBtnRef = useRef<HTMLButtonElement>(null);
  const recargarBtnRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (open) {
      // Bloqueo scroll de fondo
      const prev = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      ingresarBtnRef.current?.focus();
      return () => {
        document.body.style.overflow = prev;
      };
    }
  }, [open]);

  // Bloquear Escape
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (!open) return;
      if (e.key === "Escape") {
        e.preventDefault();
        e.stopPropagation();
      }
    };
    document.addEventListener("keydown", handler, true);
    return () => document.removeEventListener("keydown", handler, true);
  }, [open]);

  if (!open) return null;

  const renderFooter: () => JSX.Element = () => {
        return (
            <div className="p-d-flex p-flex-row-reverse p-ai-center flex-wrap">
                <div className="button-demo">
                    <div className="template">
                        <Button
                            type="button"
                            className="discord p-0"
                            aria-label="Volver a cargar"
                            onClick={onVolverACargar}
                        >
                            <i className="pi pi-spinner px-2"></i>
                            <span className="px-3">Volver a cargar</span>
                        </Button>

                        <Button
                            type="button"
                            className="amazon p-0"
                            aria-label="Ingresar manual"
                            onClick={onIngresarManual}
                        >
                            <i className="pi pi-pencil px-2"></i>

                            <span className="px-3">Ingresar manual</span>
                        </Button>
                    </div>
                </div>
            </div>
        );
    };

  return(
    <Dialog
            header={title}
            style={{ width: "40vw" }}
            footer={renderFooter}
            onHide={onVolverACargar}
            visible={open}
        >
        <div style={{ whiteSpace: "pre-line", textAlign: "left" }}>
                {Array.isArray(message) ? (
                  <ul style={{ marginLeft: "1rem", paddingLeft: "1rem" }}>
                    {message.map((e, i) => (
                      <li key={i}>{e}</li>
                    ))}
                  </ul>
                ) : (
                  <p style={{ marginLeft: "1rem" }}>{message}</p>
                )}
                {Array.isArray(message) && (
                  <p style={{ marginTop: "1rem", marginLeft: "1rem" }}>
                    Elegí cómo seguir:
                  </p>
                )}
        </div>
        </Dialog>
  );
};
